'use strict';

var insertTable = require('./transforms/insertTable');
var insertRow = require('./transforms/insertRow');
var removeRow = require('./transforms/removeRow');
var insertColumn = require('./transforms/insertColumn');
var removeColumn = require('./transforms/removeColumn');
var removeTable = require('./transforms/removeTable');
var moveSelection = require('./transforms/moveSelection');

var onEnter = require('./onEnter');
var onTab = require('./onTab');
var onBackspace = require('./onBackspace');
var onUpDown = require('./onUpDown');

var KEY_ENTER = 'enter';
var KEY_TAB = 'tab';
var KEY_BACKSPACE = 'backspace';
var KEY_DOWN = 'down';
var KEY_UP = 'up';

function EditTable(opts) {
    opts = opts || {};
    opts.typeTable = opts.typeTable || 'table';
    opts.typeRow = opts.typeRow || 'table_row';
    opts.typeCell = opts.typeCell || 'table_cell';

    /**
     * Is the selection in a table
     */
    function isSelectionInTable(state) {
        var startBlock = state.startBlock;

        // Only handle events in cells

        return startBlock.type === opts.typeCell;
    }

    /**
     * Bind a transform
     */
    function bindTransform(fn) {
        return function (transform) {
            var state = transform.state;

            var args = [].splice.call(arguments, 0);

            if (!isSelectionInTable(state)) {
                return transform;
            }

            return fn.apply(null, [opts].concat(args));
        };
    }

    /**
     * User is pressing a key in the editor
     */
    function onKeyDown(e, data, state) {
        // Only handle events in cells
        if (!isSelectionInTable(state)) {
            return;
        }

        // Build arguments list
        var args = [e, data, state, opts];

        switch (data.key) {
            case KEY_ENTER:
                return onEnter.apply(null, args);
            case KEY_TAB:
                return onTab.apply(null, args);
            case KEY_BACKSPACE:
                return onBackspace.apply(null, args);
            case KEY_DOWN:
            case KEY_UP:
                return onUpDown.apply(null, args);
        }
    }

    return {
        onKeyDown: onKeyDown,

        utils: {
            isSelectionInTable: isSelectionInTable
        },

        transforms: {
            insertTable: insertTable.bind(null, opts),
            insertRow: bindTransform(insertRow),
            removeRow: bindTransform(removeRow),
            insertColumn: bindTransform(insertColumn),
            removeColumn: bindTransform(removeColumn),
            removeTable: bindTransform(removeTable),
            moveSelection: bindTransform(moveSelection)
        }
    };
}

module.exports = EditTable;


//////////////////
// WEBPACK FOOTER
// ./~/slate-edit-table/dist/index.js
// module id = 681
// module chunks = 0